import * as v from "valibot";
import { rpcContract } from "../rpc";

// Social Auth Init - Get OAuth URL
export const socialAuthInitResultSchema = v.object({
  authUrl: v.string(),
  state: v.string(),
});

export type SocialAuthInitResult = v.InferOutput<typeof socialAuthInitResultSchema>;

export const socialAuthInitRpcContract = rpcContract({
  name: "socialAuthInit",
  paramsSchema: v.object({
    provider: v.pipe(v.string(), v.picklist(["google", "facebook", "apple"])),
  }),
  resultSchema: socialAuthInitResultSchema,
});

export type SocialAuthInitParams = v.InferOutput<typeof socialAuthInitRpcContract.paramsSchema>;

// Social Auth Callback - Handle OAuth callback
export const socialAuthCallbackResultSchema = v.object({
  accessToken: v.string(),
  isNewUser: v.boolean(),
  user: v.object({
    id: v.string(),
    email: v.string(),
    name: v.string(),
    handle: v.optional(v.string()),
  }),
});

export type SocialAuthCallbackResult = v.InferOutput<typeof socialAuthCallbackResultSchema>;

export const socialAuthCallbackRpcContract = rpcContract({
  name: "socialAuthCallback",
  paramsSchema: v.object({
    provider: v.pipe(v.string(), v.picklist(["google", "facebook", "apple"])),
    code: v.optional(v.string()), // For OAuth code flow
    token: v.optional(v.string()), // For token-based flow (frontend SDKs)
    state: v.string(),
    redirectUri: v.string(),
    // Apple-specific fields
    user: v.optional(v.string()), // Apple sends user info separately
  }),
  resultSchema: socialAuthCallbackResultSchema,
});

export type SocialAuthCallbackParams = v.InferOutput<typeof socialAuthCallbackRpcContract.paramsSchema>;

// Social Auth Link - Link social account to existing user
export const socialAuthLinkRpcContract = rpcContract({
  name: "socialAuthLink",
  paramsSchema: v.object({
    provider: v.pipe(v.string(), v.picklist(["google", "facebook", "apple"])),
    token: v.string(),
  }),
  resultSchema: v.object({
    success: v.boolean(),
  }),
});

export type SocialAuthLinkParams = v.InferOutput<typeof socialAuthLinkRpcContract.paramsSchema>;
export type SocialAuthLinkResult = v.InferOutput<typeof socialAuthLinkRpcContract.resultSchema>;

// Social Auth Unlink - Unlink social account from user
export const socialAuthUnlinkRpcContract = rpcContract({
  name: "socialAuthUnlink",
  paramsSchema: v.object({
    provider: v.pipe(v.string(), v.picklist(["google", "facebook", "apple"])),
  }),
  resultSchema: v.object({
    success: v.boolean(),
  }),
});

export type SocialAuthUnlinkParams = v.InferOutput<typeof socialAuthUnlinkRpcContract.paramsSchema>;
export type SocialAuthUnlinkResult = v.InferOutput<typeof socialAuthUnlinkRpcContract.resultSchema>;

// Get Linked Providers - Get list of linked social providers for user
export const getLinkedProvidersResultSchema = v.object({
  providers: v.array(
    v.object({
      provider: v.string(),
      email: v.string(),
      linkedAt: v.string(), // ISO date string
    }),
  ),
});

export type GetLinkedProvidersResult = v.InferOutput<typeof getLinkedProvidersResultSchema>;

export const getLinkedProvidersRpcContract = rpcContract({
  name: "getLinkedProviders",
  paramsSchema: v.object({}),
  resultSchema: getLinkedProvidersResultSchema,
});

export type GetLinkedProvidersParams = v.InferOutput<typeof getLinkedProvidersRpcContract.paramsSchema>;
